import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';

const ConfirmModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = 'تأكيد العملية', 
    message = 'هل أنت متأكد من هذا الإجراء؟',
    confirmText = 'تأكيد',
    cancelText = 'إلغاء',
    confirmButtonColor = '#dc3545',
    type = 'warning' // warning, danger, info, success
}) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const getIconColor = () => {
        switch (type) {
            case 'danger':
                return '#dc3545';
            case 'warning':
                return '#ffc107';
            case 'success':
                return '#28a745';
            case 'info':
                return '#17a2b8';
            default:
                return '#ffc107';
        }
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    {/* Backdrop - يغطي كل الشاشة بما في ذلك السايد بار والنافبار */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        className="modal-backdrop-custom"
                        onClick={onClose}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            zIndex: 9998212121,
                            backdropFilter: 'blur(3px)'
                        }}
                    />

                    {/* Modal */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, y: -50 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.8, y: -50 }}
                        className='modal-new-confirm'
                        transition={{ 
                            type: "spring",
                            stiffness: 300,
                            damping: 25
                        }}
                        style={{
                            position: 'fixed',
                            top: '15%',
                            left: '30%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 9999211221122112,
                            width: '90%',
                            maxWidth: '500px'
                        }}
                    >
                        <div 
                            className="card shadow-lg border-0"
                            style={{
                                borderRadius: '20px',
                                overflow: 'hidden'
                            }}
                        >
                            {/* Header with gradient */}
                            <div 
                                className="card-header text-white border-0 position-relative"
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    padding: '1.5rem'
                                }}
                            >
                                <button
                                    onClick={onClose}
                                    className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                                    style={{
                                        opacity: 0.8
                                    }}
                                />
                                
                                <div className="d-flex align-items-center justify-content-center mb-2">
                                    <motion.div
                                        initial={{ scale: 0, rotate: -180 }}
                                        animate={{ scale: 1, rotate: 0 }}
                                        transition={{ delay: 0.2, type: "spring" }}
                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                        style={{
                                            width: '80px',
                                            height: '80px',
                                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                            backdropFilter: 'blur(10px)'
                                        }}
                                    >
                                        <FaExclamationTriangle 
                                            style={{ 
                                                fontSize: '2.5rem',
                                                color: getIconColor()
                                            }} 
                                        />
                                    </motion.div>
                                </div>
                                
                                <h5 className="text-center mb-0 fw-bold" style={{ fontSize: '1.3rem' }}>
                                    {title}
                                </h5>
                            </div>

                            {/* Body */}
                            <div className="card-body" style={{ padding: '2rem' }}>
                                <p 
                                    className="text-center mb-0" 
                                    style={{ 
                                        fontSize: '1.1rem',
                                        color: '#495057',
                                        lineHeight: '1.8'
                                    }}
                                >
                                    {message}
                                </p>
                            </div>

                            {/* Footer */}
                            <div 
                                className="card-footer bg-light border-0"
                                style={{ padding: '1.5rem' }}
                            >
                                <div className="d-flex gap-3 justify-content-center">
                                    <motion.button
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                        onClick={onClose}
                                        className="btn btn-outline-secondary"
                                        style={{
                                            borderRadius: '12px',
                                            padding: '0.75rem 2rem',
                                            fontWeight: '600',
                                            fontSize: '1rem',
                                            minWidth: '120px',
                                            borderWidth: '2px'
                                        }}
                                    >
                                        {cancelText}
                                    </motion.button>
                                    
                                    <motion.button
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                        onClick={handleConfirm}
                                        className="btn text-white"
                                        style={{
                                            background: `linear-gradient(135deg, ${confirmButtonColor} 0%, ${confirmButtonColor}dd 100%)`,
                                            borderRadius: '12px',
                                            padding: '0.75rem 2rem',
                                            fontWeight: '600',
                                            fontSize: '1rem',
                                            minWidth: '120px',
                                            border: 'none',
                                            boxShadow: `0 4px 15px ${confirmButtonColor}40`
                                        }}
                                    >
                                        {confirmText}
                                    </motion.button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default ConfirmModal;

